import React from "react";
import { motion } from "framer-motion";
import { Mic, Radio, Sparkles, Heart, Users } from "lucide-react";

const benefits = [
  { icon: Mic, title: "Call your things", desc: "Speak naturally. Your VoloTag-enabled items listen." },
  { icon: Radio, title: "Hear them answer", desc: "A soft response points you straight to where it rests." },
  { icon: Sparkles, title: "No app gymnastics", desc: "No unlocking, tapping, staring. Just voice and reply." },
  { icon: Heart, title: "A companion, not a tracker", desc: "It feels present — small, warm, ready." },
  { icon: Users, title: "For the whole house", desc: "Kids, parents, grandparents. One gesture. Everyone gets it." },
];

const Solution = () => {
  return (
    <section
      data-testid="solution-section"
      className="relative py-28 md:py-36 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-3xl">
          <p className="text-xs tracking-[0.22em] uppercase text-blue-600 font-medium">The Shift</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-[56px] font-semibold tracking-[-0.02em] leading-[1.02]">
            Stop <span className="italic font-light text-zinc-500">searching</span>. Start <span className="italic font-light text-zinc-500">calling</span>.
          </h2>
          <p className="mt-7 text-lg md:text-xl text-zinc-600 leading-relaxed">
            VoloTag isn't another silent Bluetooth dot. It's a responsive object —
            made to be called, made to answer.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-4">
          {benefits.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`benefit-card-${i}`}
              className={`glass rounded-3xl p-7 ${i === 0 ? "md:col-span-2" : ""} ${i === 3 ? "md:col-span-2" : ""}`}
            >
              <div className="w-11 h-11 rounded-2xl bg-black text-white flex items-center justify-center">
                <b.icon className="w-5 h-5" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold tracking-tight">{b.title}</h3>
              <p className="mt-2 text-zinc-600 text-sm leading-relaxed">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solution;
